// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1foDL","footer":"ReportModalFilter_footer__2Cyuv"};